import { Stack, styled, Typography, useTheme } from "@mui/material";
import FlexRowAlign from "components/flexbox/FlexRowAlign";
import { TypographyGradient } from "components/Typography";
import { useInView, motion } from "framer-motion";
import { useRef } from "react";

const Section = styled("section")(({ theme }) => ({}));

export const Section4 = () => {
  const innerHeight = window.innerHeight;
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: false,
    margin: `${-innerHeight / 4}px`,
  });
  const theme = useTheme();

  return (
    <Section
      ref={ref}
      sx={{
        position: "relative",
        scrollSnapAlign: "center",
      }}
    >
      <Stack
        spacing={5}
        sx={{ height: "100%", width: "100%", px: { xs: 0, md: 20 } }}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <motion.div
          initial={{
            transform: `translateX(-50vw) scaleY(0)`,
            opacity: 0,
          }}
          animate={{
            transform: `translateX(${isInView ? 0 : -50}vw) scaleY(${isInView ? 1 : 0
              })`,
            opacity: isInView ? 1 : 0,
          }}
          transition={{
            type: "spring",
            stiffness: 700,
            damping: 30,
            delay: 0.2,
          }}
        >
          <Typography
            sx={{
              textTransform: "uppercase",
              fontWeight: 700,
              fontSize: { xs: 14, sm: 24, lg: 36 },
              textAlign: { xs: "center", md: "left" },
            }}
          >
            Other perpetual DEXs don’t offer yield, so the value of your assets
            depreciates over time.
          </Typography>
        </motion.div>
        <Stack sx={{ order: { xs: 1, md: 0 } }}>
          <motion.div
            style={{ width: "100%" }}
            initial={{
              transform: `translateX(50vw) scaleY(0)`,
              opacity: 0,
            }}
            animate={{
              transform: `translateX(${isInView ? 0 : 50}vw) scaleY(${isInView ? 1 : 0
                })`,
              opacity: isInView ? 1 : 0,
            }}
            transition={{
              type: "spring",
              stiffness: 700,
              damping: 40,
              delay: 0.4,
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 12, sm: 14, lg: 16 },
                fontWeight: { xs: 500, md: 700 },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Flaex is the first perpetual DEX to incorporate native yield. Your
              balance on Flaex compounds automatically.
            </Typography>
          </motion.div>
        </Stack>
        <FlexRowAlign width={"100%"} gap={{ xs: 1, md: 3 }}>
          <Stack sx={{ position: "relative", overflow: "hidden" }}>
            <img src="static/svg/grid.svg" alt="grid" />
            <motion.img
              src="static/svg/grid-y.svg"
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              initial={{
                transform: "translateY(-100%)",
              }}
              animate={{
                transform: `translateY(${isInView ? 0 : -100}%)`,
              }}
              transition={{
                delay: 0.4,
              }}
            />
            <motion.img
              src="static/svg/grid-x.svg"
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                height: "100%",
              }}
              initial={{
                transform: "translateX(-100%)",
              }}
              animate={{
                transform: `translateX(${isInView ? 0 : -100}%)`,
              }}
              transition={{
                delay: 0.6,
              }}
            />
            <motion.img
              src="static/png/area-chart.png"
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "calc(100% - 1px)",
                height: "100%",
              }}
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                delay: 0.8,
              }}
            />
            <motion.div
              style={{
                position: "absolute",
                left: 0,
                top: 0,
                height: "75%",
                transform: "rotate(-90deg)",
                aspectRatio: 1,
              }}
              initial={{
                transform: `translateX(-50px) rotate(-90deg)`,
                opacity: 0,
              }}
              animate={{
                transform: `translateX(-${isInView ? 0 : 50}px) rotate(-90deg)`,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                delay: 0.7,
              }}
            >
              <Typography
                fontWeight={700}
                fontSize={{ xs: 10, md: 16 }}
                textAlign={"center"}
              >
                USER BALANCE
              </Typography>
            </motion.div>
            <motion.div
              style={{
                position: "absolute",
                bottom: "13%",
                width: "100%",
              }}
              initial={{
                transform: `translateY(50px)`,
                opacity: 0,
              }}
              animate={{
                transform: `translateY(${isInView ? 0 : 50}px) `,
                opacity: isInView ? 1 : 0,
              }}
              transition={{
                delay: 0.8,
              }}
            >
              <Typography
                fontWeight={700}
                width={"100%"}
                textAlign={"center"}
                fontSize={{ xs: 10, md: 16 }}
                sx={{
                  transform: { xs: 'translateY(10px)', md: '' }
                }}
              >
                TIME
              </Typography>
            </motion.div>
          </Stack>
          <motion.div
            style={{ height: "100%" }}
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: isInView ? 1 : 0,
            }}
            transition={{
              delay: 1,
            }}
          >
            <Stack
              sx={{
                height: "100%",
                position: "relative",
                width: { xs: "75px", md: "135px" },
                display: { xs: 'none', md: 'flex' }
              }}
            >
              <TypographyGradient
                sx={{
                  fontSize: { xs: 9, md: 16 },
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  position: "absolute",
                  top: "25%",
                }}
              >
                FLAEX REWARDS
              </TypographyGradient>
              <TypographyGradient
                gradient={theme.palette.background.gradient}
                sx={{
                  fontSize: { xs: 9, md: 16 },
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  position: "absolute",
                  top: "52%",
                }}
              >
                FLAEX
              </TypographyGradient>
              <Typography
                sx={{
                  fontSize: { xs: 9, md: 16 },
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                  position: "absolute",
                  top: "70%",
                }}
              >
                OTHER DEXS
              </Typography>
            </Stack>
          </motion.div>
        </FlexRowAlign>
      </Stack>
    </Section>
  );
};
